import $ from 'jquery';
import template from 'art-template/lib/template-web';
import service from '../../ajax/service';
import language from '../../js/language';
import { dynamicSwiperInit } from '../../js/service';
import default_pic from "../../img/index/default-slide.png";

const index = {
  render() {
    const gameID = language.gameID;
    // 侧边栏开关
    this.bindEvent();
    // 渲染新闻栏目的轮播图
    this.renderSliderList(gameID, 'head');
    // 渲染首页文章列表
    this.renderList('234,235,236', language.get('gameID'), gameID);
    // 渲染下载链接信息
    this.renderGameInfo();
  },
  bindEvent() {
    // 侧边栏开关
    $('.j-switch-btn').on('click', () => {
      $('.j-switch-btn').toggleClass('switch-btn-close');
      $('.j-sidebar').toggleClass('sidebar-close');
    });
  },
  bineNewsEvent(res) {
    // 新闻
    let currentType = '234,235,236';
    $('.news-list-tab').on('click', ({ target }) => {
      const data = {
        list: res.data.list,
      };
      currentType = target.dataset.type;
      if (currentType) {
        data.list = res.data.list;
        if (currentType === '234,235,236') {
          $('.news-list-content').html(template('tpl_new', data));
          return;
        }
        data.list = res.data.list.filter(item => {
          return item.ARTICLE_TYPE_ID == currentType;
        });
        data.list.slice(0, 4);
        $('.news-list-content').html(template('tpl_new', data));
      }
    });

    $('.news-list-more').on('click', () => {
      window.open(
        `https://m.gm99.com/sgby/list.html?ids=234,235,236&language=zh-TW`,
        '_self'
      );
    });
  },
  renderSliderList(gameID, site) {
    service
      .getSlideList(gameID, site)
      .then(res => {
        const data = {
          list: res.data.list,
        };
        if (!data.list.length) {
          data.list.push({
            ARTICLE_TYPE_ID: '235',
            TARGET: '_self',
            URL: 'javascript:void(0)',
            PIC_URL: default_pic,
          });
        }
        $('.j-news-wrapper').html(template('tpl_news_slider', data));
        dynamicSwiperInit();
      })
      .catch(err => {
        $('.news-slider-default').show();
      });
  },
  renderList(type, articleID, gameID) {
    service
      .getArticleList(type, articleID, gameID, 1, 15)
      .then(res => {
        // 渲染首页文章列表
        const data = {
          list: res.data.list.slice(0, 4),
        };
        this.bineNewsEvent(res);
        $('.news-list-content').html(template('tpl_new', data));
      })
      .catch(err => {
        // console.log(err);
      });
  },
  renderGameInfo() {
    const gameID = language.gameID;
    service
      .getGameInfo(gameID)
      .then(({ data }) => {
        $('.j-apple-down').attr('href', data.appStoreDownLoadURL || 'javascript: alert("敬請期待")');
        $('.j-google-down').attr('href', data.googlePlayDownLoadURL || 'javascript: alert("敬請期待")');
        $('.j-apk-down').attr('href', data.apkDownLoadURL || 'javascript: alert("敬請期待")');
        $('.j-qrcode-down').attr('src', data.qrCode);
      })
      .catch(err => {
        // console.log(err);
      });
  },
};

export default index;
